module.exports = __webpack_public_path__ + "img/tif.f5bc9534.svg";